import { fieldNames } from '../../shared/configs/acceptanceForm';
import { intervalTypesMap } from '../../shared/configs/selectionData/intervalTypes';
import { mapToPayload } from './mapToPayload';
import { asIs, extractIntervalIdFromTime } from './methods';
import { defaultIntervalMode } from '../../shared/configs/selectionData/intervalModes';
import { defaultIntervalAvailability } from '../../shared/configs/selectionData/intervalAvailabilities';

const {
  intervalId: intervalIdName,
  mode: modeName,
  availability: availabilityName,
  active: activeName,
  from: fromName,
  to: toName,
  duration: durationName,
} = fieldNames.scheduleSettingInterval;

const mapper = {
  [intervalIdName]: (value) => {
    return typeof value === 'object' ? extractIntervalIdFromTime(value) : value;
  },

  [modeName]: asIs,
  [availabilityName]: asIs,
};

export const mapScheduleSettingInterval = (intervals, isDraft) => {
  const _intervals = isDraft
    ? intervals
    : intervals.filter(({ active }) => active);
  return mapToPayload(_intervals, mapper);
};

export const createMapScheduleSettingIntervalsToForm = ({
  timeIntervals,
  intervalType,
}) => {
  return (intervals) => {
    const result = [];

    intervals.forEach((i, index) => {
      const interval = timeIntervals.getIntervalById(i[intervalIdName]);

      if (intervalType === intervalTypesMap.byInterval) {
        result.push({
          i,
          [availabilityName]: Number(i[availabilityName]),
          ...createByIntervalValues(interval),
        });
        return;
      }

      result.push({
        ...i,
        [availabilityName]: Number(i[availabilityName]),
        ...createClassicValues(interval),
      });

      if (index === intervals.length - 1) {
        return;
      }

      timeIntervals.addMissingIntervals({
        accumulator: result,
        currentInterval: interval,
        nextIntervalId: intervals[index + 1][intervalIdName],
        adapter: (i) => {
          return {
            [intervalIdName]: i.id,
            [modeName]: defaultIntervalMode,
            [availabilityName]: defaultIntervalAvailability,
            ...createClassicValues(i, false),
          };
        },
      });
    });

    return result;
  };
};

function createByIntervalValues(interval) {
  return {
    [activeName]: true,
    [durationName]: interval.duration,
    [intervalIdName]: interval.from,
  };
}

function createClassicValues(interval, active = true) {
  return {
    [fromName]: interval.from.value,
    [toName]: interval.to.value,
    [activeName]: active,
  };
}
